import { useAccessoriesFetch } from '../useAccessoriesFetch';
import { useAppSelector } from '../../utils';
import { selectFlattenedCurrentVehicleFromVehicles } from '../../reducers/vehicles';
const useGetValidAccessoryKeys = (accessoryKeys) => {
    const vehicle = useAppSelector(selectFlattenedCurrentVehicleFromVehicles);
    const accessoriesData = useAccessoriesFetch(vehicle.transmissionDetIdentifier);
    const currentVehicleAccessories = accessoriesData === null || accessoriesData === void 0 ? void 0 : accessoriesData.data;
    const currentVehicleAccessoriesKeysSet = new Set(currentVehicleAccessories === null || currentVehicleAccessories === void 0 ? void 0 : currentVehicleAccessories.map(({ businessKey }) => businessKey));
    return {
        accessoriesData,
        isAccessoriesDataReady: !!(accessoriesData === null || accessoriesData === void 0 ? void 0 : accessoriesData.data),
        validAccessoriesSet: new Set(accessoryKeys.filter(key => currentVehicleAccessoriesKeysSet.has(key))),
    };
};
export default useGetValidAccessoryKeys;
